import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { DateTime } from "luxon";
import { scroller } from "react-scroll";

import Localization from "../../localization";
import Button from "../../components/button";
import Gallery from "../../components/gallery";
import Image from "../../components/image";
import { changeLogin } from "../../redux/actions/options";
import { getMe } from "../../redux/selectors/me";
import { loadPage } from "../../redux/actions/pages";
import { getUrl, fixExternalLinks } from "../../utils/helper";
import { changeFaq } from "../../redux/actions/options";

class Artistics extends Component {
    constructor(props) {
        super(props);

        this._onScroll = this._onScroll.bind(this);
    }

    componentDidMount() {
        this.props.loadPage("artistic_residencies");
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.artisticResidenciesData &&
            !prevProps.artisticResidenciesData
        ) {
            if (this.props.type === "artistic") this._onScroll();
        }
    }

    _onScroll() {
        setTimeout(() => {
            scroller.scrollTo("container-artistic", {
                duration: 700,
                smooth: true,
            });
        }, 0);
    }

    _renderSection(section, image, gallery, openCall, open) {
        const { locale } = this.props;

        return (
            <div key={section.key}>
                <div className="hidden xl:flex mb-40">
                    <div className="w-4/12" />
                    <div className="w-8/12">
                        <h1 className="font-judge font-bold text-30 text-blue">
                            {section.attributes.title}
                        </h1>
                    </div>
                </div>
                <div className="hidden xl:flex">
                    <div className="w-3/12 relative">
                        {image && (
                            <div className="absolute top-0 bottom-0 right-0 left-0">
                                <Image
                                    alt={image.alt || section.attributes.title}
                                    url={image.url}
                                    aspectRatio="aspect-ratio-85/96"
                                />
                            </div>
                        )}
                    </div>
                    <div className="w-1/12" />
                    <div className="w-8/12">
                        <p className="font-bold text-60 text-blue">
                            {section.attributes.subtitle}
                        </p>
                    </div>
                </div>
                <h1 className="xl:hidden font-judge mb-30 font-bold text-17 text-blue">
                    {section.attributes.title}
                </h1>
                <p className="xl:hidden font-bold text-30 mb-30 text-blue">
                    {section.attributes.subtitle}
                </p>
                <div className="xl:hidden w-8/12">
                    {image && (
                        <Image
                            alt={image.alt || section.attributes.title}
                            url={image.url}
                            aspectRatio="aspect-ratio-3/4"
                        />
                    )}
                </div>
                <div className="flex mt-30 xl:mt-40 xl:mb-40">
                    <div className="xl:flex-1" />
                    <div
                        className="article-body leading-tight text-17 xl:text-23 text-blue w-full xl:w-6/12"
                        dangerouslySetInnerHTML={{
                            __html: fixExternalLinks(section.attributes.body),
                        }}
                    />
                </div>
                {openCall && (
                    <div
                        className="article-body xl:hidden my-30 text-17 text-blue"
                        dangerouslySetInnerHTML={{
                            __html: fixExternalLinks(openCall.conditions),
                        }}
                    />
                )}
                {openCall && (
                    <div className="flex flex-col xl:flex-row">
                        <div className="xl:w-1/12" />
                        <div className="xl:w-2/12">
                            <Button
                                text={Localization[locale].account.button_faqs}
                                textStyle={
                                    "w-full font-bold text-20 xl:text-23 z-10 text-center transition hover-hover:group-hover:text-white text-blue"
                                }
                                style={"mb-8 w-full"}
                                onClick={() => {
                                    this.props.changeFaq(true, 0);
                                }}
                            />
                            {openCall.rules && (
                                <Button
                                    text={
                                        openCall.rules_button ||
                                        Localization[locale].account
                                            .button_rules
                                    }
                                    textStyle={
                                        "w-full font-bold text-20 xl:text-23 z-10 text-center transition hover-hover:group-hover:text-white text-blue"
                                    }
                                    style={"mb-8 w-full"}
                                    to={getUrl("opencalls/artistic/rules")}
                                />
                            )}
                            {openCall.judges && (
                                <Button
                                    text={
                                        openCall.judges_button ||
                                        Localization[locale].account.button_jury
                                    }
                                    textStyle={
                                        "w-full font-bold text-20 xl:text-23 z-10 text-center transition hover-hover:group-hover:text-white text-blue"
                                    }
                                    style={"mb-8 w-full"}
                                    to={getUrl("opencalls/artistic/judges")}
                                />
                            )}
                            {openCall.external && (
                                <Button
                                    text={
                                        openCall.external_button ||
                                        Localization[locale].account
                                            .button_external
                                    }
                                    textStyle={
                                        "w-full font-bold text-20 xl:text-23 z-10 text-center transition hover-hover:group-hover:text-white text-blue"
                                    }
                                    style={"mb-8 w-full"}
                                    to={getUrl("opencalls/artistic/external")}
                                />
                            )}
                            {openCall.mentors && (
                                <Button
                                    text={
                                        openCall.mentors_button ||
                                        Localization[locale].account
                                            .button_mentors
                                    }
                                    textStyle={
                                        "w-full font-bold text-20 xl:text-23 z-10 text-center transition hover-hover:group-hover:text-white text-blue"
                                    }
                                    style={"mb-8 w-full"}
                                    to={getUrl("opencalls/artistic/mentors")}
                                />
                            )}
                        </div>
                        <div className="xl:w-1/12" />
                        <div className="hidden xl:block w-5/12">
                            <div
                                className="article-body text-17 text-blue xl:mb-80"
                                dangerouslySetInnerHTML={{
                                    __html: fixExternalLinks(
                                        openCall.conditions
                                    ),
                                }}
                            />
                        </div>
                    </div>
                )}
                {openCall.results && (
                    <div className="xl:flex xl:justify-center">
                        <Button
                            text={
                                Localization[this.props.locale].open_calls
                                    .button_results
                            }
                            textStyle={
                                "font-bold text-20 xl:text-23 z-10 transition hover-hover:group-hover:text-white text-blue"
                            }
                            onClick={() => {
                                if (!this.props.user) {
                                    this.props.changeLogin(true);
                                }
                            }}
                            to={
                                this.props.user &&
                                getUrl("opencalls/artistic/results")
                            }
                            style={"w-full xl:w-auto mb-8"}
                            wrapperStyle="px-15"
                        />
                    </div>
                )}
                {open && (
                    <div className="xl:flex xl:justify-center">
                        <Button
                            text={
                                Localization[this.props.locale].open_calls
                                    .button_application_open
                            }
                            textStyle={
                                "font-bold text-20 xl:text-23 z-10 transition hover-hover:group-hover:text-white text-blue"
                            }
                            onClick={() => {
                                if (!this.props.user) {
                                    this.props.changeLogin(true);
                                }
                            }}
                            to={this.props.user && getUrl("account/artistic")}
                            style={"w-full xl:w-auto"}
                            wrapperStyle="px-15"
                        />
                    </div>
                )}
                {!open && (
                    <div className="flex mt-20 xl:mt-0 justify-center">
                        <Button
                            text={
                                Localization[this.props.locale].open_calls
                                    .button_soon
                            }
                            comingSoon={true}
                            style={"m-8"}
                            textStyle={"font-bold text-20 xl:text-23 text-blue"}
                        />
                    </div>
                )}
                {gallery && (
                    <div className="flex justify-center">
                        <Gallery data={gallery} />
                    </div>
                )}
            </div>
        );
    }

    render() {
        const { artisticResidenciesData, openCallsData } = this.props;

        if (!artisticResidenciesData) return null;

        let openCallOpen = false;
        const openCall = openCallsData.find((item) => item.type === "artistic");

        if (openCall) {
            const now = DateTime.local();
            const begin = DateTime.fromISO(openCall.begin);
            const end = DateTime.fromISO(openCall.end);

            if (
                now.toMillis() >= begin.toMillis() &&
                now.toMillis() <= end.toMillis()
            ) {
                openCallOpen = true;
            }
        }

        return (
            <div
                name="container-artistic"
                className="bg-pink pt-40 xl:pt-100 pb-60 xl:pb-100 px-16 xl:px-50"
            >
                {artisticResidenciesData.content.map((section) =>
                    this._renderSection(
                        section,
                        artisticResidenciesData.image,
                        artisticResidenciesData.gallery,
                        openCall,
                        openCallOpen
                    )
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.app.locale,
    user: getMe(state),
    artisticResidenciesData: state.pages.artistic_residencies,
    openCallsData: state.openCalls.data,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            changeFaq,
            changeLogin,
            loadPage,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Artistics);
